import { render, staticRenderFns } from "./costCountsTable.vue?vue&type=template&id=1952afe3&scoped=true&"
import script from "./costCountsTable.vue?vue&type=script&lang=js&"
export * from "./costCountsTable.vue?vue&type=script&lang=js&"
import style0 from "./costCountsTable.vue?vue&type=style&index=0&id=1952afe3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952afe3",
  null
  
)

export default component.exports